export const appendFlexOrderAttributes = <T extends Record<string, any>>(
  order: T,
  isFlexEnabled: boolean,
  defaultPortionCount?: number,
): T => {
  if (!isFlexEnabled) {
    return order
  }

  return {
    ...order,
    attributes: {
      ...(order.attributes ?? {}),
      ...(defaultPortionCount ? { default_portion_count: defaultPortionCount } : {}),
    },
  }
}
